import styled from "styled-components";
import { ITrackProps } from "react-range/lib/types";

import { getMarginX, getMarginY } from "../utils";

interface StyledTrackProps extends ITrackProps {
  height: number;
  thumbSize: number;
}

export default styled.div<StyledTrackProps>`
  width: 100%;
  margin: ${({ height, thumbSize }) => getMarginY(thumbSize, height)}px 0;
  height: ${({ height }) => height}px;
  background-color: rgba(255, 255, 255, 0.65);

  // Added bigger ends
  &::before,
  &::after {
    content: "";
    width: ${({ thumbSize }) => Math.round(getMarginX(thumbSize))}px;
    height: 100%;
    display: block;
    position: absolute;
    background-color: inherit;
    z-index: -1;
  }

  &::before {
    top: 0px;
    left: -${({ thumbSize }) => Math.round(getMarginX(thumbSize))}px;
  }

  &::after {
    top: 0px;
    right: -${({ thumbSize }) => Math.round(getMarginX(thumbSize))}px;
  }
`;
